export default __webpack_public_path__ + "static/executive-thumbnail-60b6be7db3695293835de9f22aaef7a5.jpg";